import { bootstrapApplication } from '@angular/platform-browser'
import { appConfig } from './app/app.config'
import { AppComponent } from './app/app.component'
import { provideRouter } from '@angular/router'
import { routes } from './app/app.routes'
import { provideAnimations } from '@angular/platform-browser/animations'
import { HTTP_INTERCEPTORS, provideHttpClient } from '@angular/common/http'
import { HttpServiceHelper } from './app/common/http-service-helper'
import { HttpConfigInterceptor } from './app/services/httpconfig.interceptor'

bootstrapApplication(AppComponent, {
    providers: [
        provideRouter(routes),
        provideAnimations(),
        provideHttpClient(),
        HttpServiceHelper,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpConfigInterceptor,
            multi: true
        }
    ]
}).catch((err) => console.error(err))
